import React, { Fragment } from 'react';
import T from 'prop-types';
import { SelectedBrandsContainer, styles } from './styles';
import strings from '../../../../../localization';
import { renderNamesFromArrThroughCommas } from '../../../../../utils/stringHelper';
import { TextButton, Text } from '../../../../ReusableComponents';

class SelectedBrands extends React.PureComponent {
  render() {
    const { selectedBrands, onResetSelectedBrands } = this.props;

    return (
      <Fragment>
        <SelectedBrandsContainer>
          <Text style={styles.brandNameText}>
            {strings.filters.selected}: {renderNamesFromArrThroughCommas(selectedBrands)}
          </Text>
          <TextButton
            alignCenter
            small
            title={strings.filters.reset}
            onPress={onResetSelectedBrands}
          />
        </SelectedBrandsContainer>
      </Fragment>
    );
  }
}
SelectedBrands.propTypes = {
  selectedBrands: T.array,
  onResetSelectedBrands: T.func,
};
export default SelectedBrands;
